import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import { Toaster } from "sonner";
import "./App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { EditorialMarquee } from "./components/EditorialMarquee";
import { Services } from "./components/Services";
import { HowItWorks } from "./components/HowItWorks";
import { Rates } from "./components/Rates";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { MigrationBanner } from "./components/MigrationBanner";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#12071F] text-[#F8F7FA] font-body overflow-x-hidden">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <HowItWorks />
        <Rates />
        <Contact />
      </main>
      <Footer />
      <MigrationBanner />
      <WhatsAppButton />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
